import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CommonDialog from "../../common/commonDialog";
import moment from "moment";
import { formatMoney } from "../../../constants/utils";

const useStyles = makeStyles((theme) => ({
  checkLabelFont: {
    marginLeft: "12px!important",
    color: "#292929!important",
    fontSize: "1rem!important",
  },
}));

const FutureOverdueProvPartywiseModal = (props) => {
  const classes = useStyles();
  const {
    customerRowData,
    setCustomerRowData,
    open,
    onCancel,
    //onSave,
    //showSubmitButton,
    //selectedItemBCStatus,
  } = props;

  console.log(customerRowData, "customerRowData");

  const [claimDetails, setClaimDetails] = useState([]);

  /*  useEffect(() => {
    setClaimDetails(data.claimDetails);
  }, [data.claimDetails]); */

  const onInputChange = (event) => {
    const { name, value } = event.target;
    customerRowData[name] = value;
    if (name === "status") {
      if (value === "Y") {
        /*  if (data.claimDetails != null && data.claimDetails.length > 0) {
          setClaimDetails(data.claimDetails);
        } else {
          claimDetails.push(initialValues);
          setClaimDetails([...claimDetails]);
        } */
      } else {
        setClaimDetails([]);
      }
    }
    setCustomerRowData({ ...customerRowData });
  };

  const [openAddMoreClaimDialog, setOpenAddMoreClaimDialog] = useState(false);

  const initialValues = {
    amount: "",
    recoverableDate: "",
    remarks: "",
  };
  const [claimData, setClaimData] = useState(initialValues);

  const onClaimPopUpInputChange = (event) => {
    const { name, value } = event.target;
    console.log(name, "name");
    console.log(value, "value");
    claimData[name] = value;
    setClaimData({ ...claimData });
  };

  const addClaims = () => {
    claimDetails.push(claimData);
    setClaimDetails([...claimDetails]);
    setClaimData(initialValues);
    setOpenAddMoreClaimDialog(false);
  };

  return (
    <>
      <CommonDialog
        onCancel={onCancel}
        onSave={() => {}}
        open={open}
        primaryButtonLabel={"Submit"}
        title={"Future OD/Prov. Recovery Details"}
        maxWidth="md"
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <div>
              How much of the <b>Future Overdue</b> -{" "}
              <span style={{ color: "red" }}>
                Rs.{formatMoney(customerRowData?.futureOverdue?.toFixed(0))}
              </span>{" "}
              is recoverable from the customer {customerRowData?.customerName}{" "}
              {customerRowData?.customerCode}?
            </div>
          </Grid>
          {/*  <Grid item sm={6} xs={12}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="status"
                value={rowData?.status}
                onChange={onInputChange}
              >
                <FormControlLabel
                  value="Y"
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#f91e26",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 23,
                        },
                      }}
                    />
                  }
                  label={
                    <Typography
                      variant="body1"
                      fontSize={15}
                      sx={{ color: "#292929" }}
                    >
                      Yes
                    </Typography>
                  }
                  className={classes.checkFont}
                />

                <FormControlLabel
                  value="N"
                  control={
                    <Radio
                      sx={{
                        "&.Mui-checked": {
                          color: "#f91e26",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 23,
                        },
                      }}
                    />
                  }
                  label={
                    <Typography
                      variant="body1"
                      fontSize={15}
                      sx={{ color: "#292929" }}
                    >
                      No
                    </Typography>
                  }
                  className={classes.checkFont}
                />
              </RadioGroup>
            </FormControl>
          </Grid> */}
          <hr />
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="amount"
              label="Amount Recoverable"
              size="small"
              type="number"
              name="amount"
              value={claimData.amount}
              onChange={onClaimPopUpInputChange}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="goodsAmount"
              label="Goods Return"
              size="small"
              type="number"
              name="goodsAmount"
              value={claimData.amount}
              onChange={onClaimPopUpInputChange}
            />
          </Grid>

          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="recoverableDate"
              label="Recovery Date"
              size="small"
              type="date"
              name="recoverableDate"
              value={claimData.recoverableDate}
              onChange={onClaimPopUpInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="remarks"
              label="Add breakup of payments and date"
              size="small"
              type="text"
              multiline
              rows={1}
              name="remarks"
              value={claimData.remarks}
              onChange={onClaimPopUpInputChange}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="outlined-select-currency"
              select
              label="Billing Class"
              size="small"
              name="searchAsm"
              value={claimData.amount}
              onChange={onClaimPopUpInputChange}
            >
              <MenuItem key={"A"} value={"A"}>
                {"A"}
              </MenuItem>
              <MenuItem key={"B"} value={"B"}>
                {"B"}
              </MenuItem>
              <MenuItem key={"C"} value={"C"}>
                {"C"}
              </MenuItem>
              <MenuItem key={"D"} value={"D"}>
                {"D"}
              </MenuItem>
            </TextField>
          </Grid>
          {customerRowData?.status === "N" && (
            <Grid item sm={12} xs={12}>
              <TextField
                fullWidth
                id="remarks"
                label="Remarks"
                size="small"
                type="textarea"
                name="remarks"
                multiline
                rows={1}
                value={customerRowData.remarks}
                onChange={onInputChange}
              />
            </Grid>
          )}
          {customerRowData?.status === "Y1" && (
            <>
              <Grid item sm={12} xs={12}>
                <Button
                  color={"secondary"}
                  variant="outlined"
                  type="button"
                  className={`${classes.btnClass}`}
                  onClick={() => setOpenAddMoreClaimDialog(true)}
                >
                  Add Recovery Details
                </Button>
              </Grid>
              <Grid item sm={12} xs={12}>
                {claimDetails.length > 0 && (
                  <Grid item sm={12} xs={12}>
                    <div className="user-status table-responsive text-center">
                      <table className="table table-bordernone mb-0">
                        <thead>
                          <tr>
                            <th scope="col">Amount</th>
                            <th scope="col">Recoverable Date</th>
                            <th scope="col">Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                          {claimDetails.map((row, index) => {
                            return (
                              <tr key={index}>
                                <td>{formatMoney(row.amount)}</td>
                                <td>{row.recoverableDate}</td>
                                <td>{row.remarks}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </Grid>
                )}
              </Grid>
            </>
          )}
        </Grid>
      </CommonDialog>

      <CommonDialog
        open={openAddMoreClaimDialog}
        title="Add Recoverable Details"
        onCancel={() => setOpenAddMoreClaimDialog(false)}
        primaryButtonLabel={"Add"}
        onSave={addClaims}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="amount"
              label="Amount Recoverable"
              size="small"
              type="number"
              name="amount"
              value={claimData.amount}
              onChange={onClaimPopUpInputChange}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="recoverableDate"
              label="Recover Date"
              size="small"
              type="date"
              name="recoverableDate"
              value={claimData.recoverableDate}
              onChange={onClaimPopUpInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <TextField
              fullWidth
              id="remarks"
              label="Remarks"
              size="small"
              type="text"
              multiline
              rows={1}
              name="remarks"
              value={claimData.remarks}
              onChange={onClaimPopUpInputChange}
            />
          </Grid>
        </Grid>
      </CommonDialog>
    </>
  );
};

export default FutureOverdueProvPartywiseModal;
